import { queryOptions, useQuery } from '@tanstack/react-query';

import { mySettingsQueryOptions } from '../../close-the-loop';
import type { MySettings, OnboardingState } from '../../close-the-loop';

const onboardingOf = (settings: MySettings): OnboardingState | null => settings.onboarding;

export const onboardingStatusQueryOptions = () =>
  queryOptions({ ...mySettingsQueryOptions(), select: onboardingOf, throwOnError: false });

export const useOnboardingStatus = (): OnboardingState | null | undefined => useQuery(onboardingStatusQueryOptions()).data;
